module.exports = __webpack_public_path__ + "fonts/material-icons-outlined.0ba49c0.woff2";